import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  output,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';

import {
  MatDrawer,
  MatDrawerContainer,
  MatDrawerContent,
} from '@angular/material/sidenav';
import { ModalFormComponent } from '../../../../shared/components/modal-form/modal-form.component';
import { ModalTeledeteccionComponent } from '../modal-teledeteccion/modal-teledeteccion.component';
import { TeledeteccionArea } from '../../../../model/teledeteccion-area.model';

@Component({
  selector: 'app-teledeteccion-container',
  templateUrl: './teledeteccion-container.component.html',
  styleUrls: ['./teledeteccion-container.component.scss'],
  imports: [
    MatDrawerContainer,
    MatDrawerContent,
    MatDrawer,
    ModalFormComponent,
    ModalTeledeteccionComponent,
  ],
})
export class TeledeteccionContainerComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('drawer') drawer: MatDrawer;

  // Output para comunicar al componente padre
  areaCreated = output<TeledeteccionArea | undefined>();

  fullRendered = false; // variable para saber si el componente ya se renderizo en pantalla
  opened_menu_panel = false;
  obs$: Subscription;
  component = 'tele-drawer-componente'; // Componente que se va a renderizar en el panel lateral

  constructor() {}

  ngOnInit(): void {
    // Aquí puedes suscribirte a servicios para controlar el estado del panel
    // Por ejemplo, si tienes un servicio de teledetección similar al VisorgisService
  }

  ngAfterViewInit(): void {
    this.fullRendered = true;
  }

  ngOnDestroy(): void {
    if (this.obs$) {
      this.obs$.unsubscribe();
    }
    console.log('MapContainer component destroyed');
  }

  onCloseDrawer(): void {
    this.opened_menu_panel = false;
    // Aquí puedes notificar a un servicio sobre el cambio de estado
  }

  openDrawer(): void {
    this.opened_menu_panel = true;
    this.drawer.open();
  }

  onAreaCreated(area: TeledeteccionArea | undefined): void {
    console.log('🏠 Container recibe área creada:', area);
    // Emitir al componente padre (TeledeteccionComponent)
    this.areaCreated.emit(area);
  }
}
